import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ShareAttachmentModal } from '../components/ShareAttachmentModal'
import {
  actionCreators,
  IShareAttachmentState,
  selectAttachment,
  selectIsSaving,
  selectListing,
  selectListingShareType,
  selectPropertyId,
} from '../modules/shareAttachment'

export default connect(
  createStructuredSelector<ApplicationState, IShareAttachmentState>({
    attachment: selectAttachment(),
    isSaving: selectIsSaving(),
    listing: selectListing(),
    listingShareType: selectListingShareType(),
    propertyId: selectPropertyId(),
  }),
  actionCreators,
)(ShareAttachmentModal)
